import { render, staticRenderFns } from "./FormTaxImport.vue?vue&type=template&id=e350ff1c"
import script from "./FormTaxImport.vue?vue&type=script&lang=js"
export * from "./FormTaxImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports